import React, {useEffect, useState} from 'react';
import EditRound from '../Round/EditRound';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import { useRounds } from '../../Data/Rounds';
import { Link } from 'react-router-dom';
import Dropdown from '../../Components/Dropdown';
import Statuses from '../../Components/Widgets/Jobs/Statuses';
import API from '../../Services/API';
import { useDialogues } from '../../Components/Dialogues';
import ListViewLoading from '../../Components/EmptyStates/ListViewLoading';
import NoItems from '../../Components/EmptyStates/NoItems';
import { getEntityLink } from '../../Services/helpers';
import ScheduleRound from '../Round/ScheduleRound';
import Search, { SearchBar, useSearch } from '../../Components/Search';
import Callback from '../../Services/Callback';
import MarkRoundDone from '../Round/MarkRoundDone';

const refreshCallback = new Callback();

const Rounds = () => {

    const [editing, setEditing] = useState(null);
    const [scheduling, setScheduling] = useState(null);
    const [markingDone, setMarkingDone] = useState(null);

    return <>
        <TopBar
            title="Rounds"
            dropdownOptions={[
                {
                    title: 'Add round',
                    icon: 'Plus',
                    onClick: () => setEditing({})
                }
            ]}
        />
        <Page>
            <Search persist="rounds-search">
                <Inner {...{setEditing, setScheduling, setMarkingDone, refreshCallback}} />
            </Search>

            <EditRound isOpen={!!editing} round={editing} onClose={() => setEditing(null)} onSave={() => refreshCallback.invoke()} />
            <ScheduleRound isOpen={!!scheduling} round={scheduling} onClose={() => setScheduling(null)} onSave={() => refreshCallback.invoke()} />
            <MarkRoundDone isOpen={!!markingDone} round={markingDone} onClose={() => setMarkingDone(null)} onSave={() => refreshCallback.invoke()} />
        </Page>
    </>
}

const Inner = ({setEditing, setScheduling, setMarkingDone, refreshCallback}) => {
    const {searchDebounced, liveSearch} = useSearch();
    const {rounds, refresh, isLoading} = useRounds(searchDebounced, true);

    useEffect(() => {
        return refreshCallback.listen(() => refresh());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (rounds === null) {
        return <>
            <SearchBar isLoading={isLoading} />
            <ListViewLoading layout="ImageLeft" count="4" />
        </>
    }

    return <>
        <SearchBar isLoading={isLoading} />
        <List {...{rounds: liveSearch(rounds), setEditing, setScheduling, setMarkingDone, refresh}} />
    </>
}

const List = ({rounds, setEditing, setScheduling, setMarkingDone, refresh}) => {
    return  <ul className="divide-y divide-gray-200">
        {rounds.map(round => <Round key={round.id} {...{round, setEditing, setScheduling, setMarkingDone, refresh}} />)}
        <li className="py-3">
            <NoItems icon="ArrowProgress" title="Add a round" onClick={() => setEditing({})} />
        </li>
    </ul>
}

const Round = ({round, setEditing, setScheduling, setMarkingDone, refresh}) => {
    const {confirm} = useDialogues();
    const size = 120;
    const thumbnail = API.url(`/rounds/${round.id}/thumbnail.png?size=${size}x${size}`);
    const link = getEntityLink('Rounds/Round', round.id);

    return <li className="flex items-center justify-between gap-x-4 py-3">
        <Link to={link} className={`w-[${size}px] h-[${size}px] block shrink-0`}>
            <img src={thumbnail} alt="Round map preview" width={size} height={size} className="rounded-lg" />
        </Link>
        <Link to={link} className="w-full block grow shrink">
            <div className="min-w-0">
                <p className="text-sm leading-6 text-gray-900 font-semibold">
                    {round.name}
                </p>
                <Statuses jobs={round.jobStatuses} size="45" limit={Math.floor((window.innerWidth - 250) / 70 )} />
            </div>
        </Link>
        <div>
            <Dropdown options={[
                {
                    title: 'Schedule jobs',
                    icon: 'CalendarPlus',
                    onClick: () => setScheduling(round)
                },
                {
                    title: 'Mark jobs as done',
                    icon: 'Check',
                    onClick: () => setMarkingDone(round)
                },
                {
                    div: true,
                },
                {
                    title: 'Edit',
                    icon: 'Pencil',
                    onClick: () => setEditing(round)
                },
                {
                    title: 'Delete',
                    icon: 'Trash',
                    onClick: () => confirm(
                        {theme: 'danger', title: 'Delete round', message: 'Really delete this round?'},
                        () => API.delete(`/rounds/${round.id}`).then(refresh)
                    )
                }
            ]} />
        </div>
    </li>;
}

export default Rounds;
